import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VioTablesModule } from 'vio-tables';
import { TABLE_CONFIG, TABLE_HEADER } from '../../../../node_modules/vio-tables/lib/Interfaces/commonInterfaces';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SetConfigurationModalComponent } from '../set-configuration-modal/set-configuration-modal.component';
import { CommonFunctionService } from '../../services/common-function.service';
import { FormsObjectType, VioInputModule } from 'vio-input';
import { ApiRequestsService } from '../../services/api-requests.service';
@Component({
  selector: 'app-configuration-setting',
  standalone: true,
  imports: [NgbModule, NgbDropdownModule, VioTablesModule, CommonModule, FormsModule, VioInputModule],
  templateUrl: './configuration-setting.component.html',
  styleUrl: './configuration-setting.component.scss'
})
export class ConfigurationSettingComponent implements OnInit {
  @Input() data: any = {};


  tableConfig: TABLE_CONFIG = {
    displayFormat: 'table',
    isSortable: true,
    isCheckBox: false,
    // "cellContextMenu": true,
    headerContextMenu: true,
    condition: false,
    displayBtnDiv: true,
    exporttoexcel: true,
    isButtonHover: true,
    formSearchBtnAt: 'start',
    cssClass: 'vio-table-bordered',

    headerContextMenuList: [
      {
        label: 'Hide Column',
        action: 'hidecolumn',
      },
      {
        label: 'Display Hidden Columns',
        action: 'displayhiddencols',
      },
      {
        label: 'Freeze Column(s)',
        action: 'freezecolumn',
      },
      {
        label: 'Unfreeze Column',
        action: 'unfreeze',
      },
      {
        label: 'Aggregate',
        action: 'aggregate',
      },
      {
        label: 'Remove Aggregate',
        action: 'removeaggregate',
      },
    ],
    actionButtons: [
      {
        btnName: 'Edit',
        btnTitle: 'Edit',
        btnIcon: 'fa fa-pen',
        btnClass: 'btn-primary mt-1',
      },
      {
        btnName: 'Delete',
        btnTitle: ' Delete',
        btnIcon: 'fa fa-trash',
        btnClass: 'btn-primary mt-1',
      }
    ],
  };

  showTable: boolean = true;

  tableHeader: TABLE_HEADER[] = [
    { key: 'param', display: 'Parameter Name', datatype: 'string' },
    { key: 'key', display: 'Key Name', datatype: 'string' },
    { key: 'multFactor', display: 'Multiplication Factor', datatype: 'number' },
    { key: 'unit', display: 'Unit', datatype: 'string' }
  ]

  tableData: any[] = [];

  configForm: FormsObjectType = {
    config: {
      numberOfColumnsInRow: 1,
      formSubmitURL: '',
      isInvalidNoRequiredFieldSubmitted: false,
      showError: 'Inline',
      showLineBellowGroup: false,
      displayType: 'Floating',
    },
    fields: {
      ctName: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Configuration Name', label: 'Configuration Name', value: '', marginPading: 'mt-1 mb-1', columnSize: 3, },
      ctDescr: { dataType: 'string', inputType: 'text', groupName: '', groupHeading: '', isRequired: true, isReadOnly: false, isHidden: false, placeHolder: 'Enter Description', label: 'Description', value: '', marginPading: 'mt-1 mb-1', columnSize: 9, },
    },
  };

  constructor(private ngbModal: NgbModal, public ngbActiveModal: NgbActiveModal, public common: CommonFunctionService, private apiRequests: ApiRequestsService) { }

  getConfigurationTemplateSetting = async () => {
    let { errorCode, errorDescription, Data } = await this.apiRequests.postAPICallWithPromise('messageconfig/getConfigurationDetails', { id: this.data['_id'] });
    if (errorCode == this.apiRequests.NO_ERROR) {
      this.tableData = Data;
    }

  }
  ngOnInit(): void {
    this.common.pageTitle = 'Manage Configuration';
    if (this.data['_id']) {
      this.configForm.fields['ctName']['isReadOnly'] = true;
      this.common.assignObjectValuesToVioInputComponent(this.configForm.fields, this.data);
      this.getConfigurationTemplateSetting();
    } else {
      this.configForm.fields['ctName']['isReadOnly'] = false;
    }
  }


  setConfigModal = async (paramInfo: any) => {
    const ngbModelRef = this.ngbModal.open(SetConfigurationModalComponent, {
      windowClass: 'set-config-modal',
      backdrop: 'static',
      backdropClass: 'set-config-modal-backdrop',
    }); /****fullscreen: true, scrollable: true*/

    ngbModelRef.componentInstance.paramInfo = paramInfo;

    const result = await ngbModelRef.result;
    console.log('Result from modal', result)
    let parameterObj = result;
    console.log(`Returned parameter = `, parameterObj);
    let tableRows = JSON.parse(JSON.stringify(this.tableData));
    if (parameterObj['idx'] > -1) {
      let idx = parameterObj['idx'];
      delete parameterObj['idx'];
      tableRows[idx] = { ...tableRows[idx], ...parameterObj }
      this.tableData = tableRows;
    } else {
      delete parameterObj['idx'];
      tableRows.push(parameterObj)
      this.tableData = tableRows;
    }
    console.log('Table Data after return = ', this.tableData)

  };


  buttonClickEvent = (event: any) => {
    console.log('table button click event = ', event)
    let rowData = JSON.parse(JSON.stringify(event.eventRow));
    rowData['idx'] = event.rowIndex;
    if (event.buttonName.btnName == 'Edit') {
      this.setConfigModal(rowData);
    }
  }

  saveConfig = async (result: string) => {
    let configObj: any = { _id: this.data['_id'], ctName: this.configForm.fields['ctName'].value, ctDescr: this.configForm.fields['ctDescr'].value }
    configObj['parameters'] = this.tableData.map((p: any) => ({ param: p.param, key: p.key, multFactor: p.multFactor, unit: p.unit }))
    let { errorCode, errorDescription, Data } = await this.apiRequests.postAPICallWithPromise('messageconfig/saveConfiguration', configObj)

    if (errorCode == this.apiRequests.NO_ERROR) {
      this.closeModal({ message: "Configuration updated successfully", action: 'Success' });
    } else {
      this.closeModal({ message: errorDescription, action: 'Error' });
    }
  }


  changeEvent(event: any) {
    console.log('Event Selected = ', event)
    console.log(`Is checked = `, event.checkState)
    if (event.checkState) {
      this.setConfigModal(event.event.value);
    }

  }

  checkDataEvent(event: any) {
    console.log('====================================');
    console.log(event);
    console.log('====================================');

  }
  closeDialog = (result: string) => {
    this.closeModal({ message: "", action: result })
  }

  closeModal(returnObj: { message: string, action: string }) {
    this.ngbActiveModal.close(returnObj);
  }



}
